module.exports = __webpack_public_path__ + "static/media/logo_haibunda_(1).94a752e3.png";